// extracted by mini-css-extract-plugin
export default {"logoLink":"LogoLink_logoLink__wW1-Z","logoLinkIcon":"LogoLink_logoLinkIcon__5jhRD","bgPulse":"LogoLink_bgPulse__ZpPpC"};